// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Icon from "../images-and-icons/Icon.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Tooltip from "./Tooltip.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
function TooltipIcon(props) {
  let __iconSize = props.iconSize;
  let __crossOffset = props.crossOffset;
  let __offset = props.offset;
  let altTriggerRef = props.altTriggerRef;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "info";
  let offset = __offset !== undefined ? __offset : 1;
  let crossOffset = __crossOffset !== undefined ? __crossOffset : -1;
  let iconSize = __iconSize !== undefined ? __iconSize : 13;
  let nextVariation = variation === "quiet_more" || variation === "quiet_info";
  let placement = Stdlib_Option.getOr(props.placement, nextVariation ? "top" : "bottom start");
  let arrowed = Stdlib_Option.getOr(props.arrowed, nextVariation);
  let match = Hover.use(altTriggerRef, undefined, undefined);
  let hovered = match[1];
  let match$1 = React.useState(() => false);
  let setOpened = match$1[1];
  let debouncedHovered = ReactUpdateDebounced.use(hovered, hovered ? 75 : 100);
  let opened = Stdlib_Option.mapOr(altTriggerRef, match$1[0], param => debouncedHovered);
  let onOpenChange = opened => {
    if (Stdlib_Option.isNone(altTriggerRef)) {
      return setOpened(param => opened);
    }
  };
  React.useEffect(() => {
    let domElement = Stdlib_Option.flatMap(altTriggerRef, ref => Primitive_option.fromNullable(ref.current));
    if (domElement !== undefined) {
      ReactDomElement.setDomElementStyleProp(Primitive_option.valFromOption(domElement), "cursor", "help");
    }
  }, [altTriggerRef]);
  let match$2 = {
    className: "cursor-x1146j2 display-xjp7ctv",
    "data-style-src": "wino-gc:src/resources/overlays/TooltipIcon.res.js:16"
  };
  let active = debouncedHovered || opened;
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx("div", {
      children: nextVariation ? JsxRuntime.jsx(Icon.make, {
        name: variation === "quiet_info" ? "status_info" : "status_add",
        fill: "#25243A",
        width: iconSize | 0,
        height: iconSize | 0
      }) : JsxRuntime.jsx(LegacyIcon.make, {
        name: variation === "info" ? "info_tip" : "alert_tip",
        fill: variation === "info" ? active ? "#25243a" : "#a2a1b0" : variation === "alert" ? active ? active ? "#25243a" : "#a2a1b0" : "#535165" : active ? "#25243a" : "#a2a1b0",
        size: iconSize
      }),
      ref: Primitive_option.some(match[0]),
      className: match$2.className,
      style: match$2.style
    }),
    arrowed: arrowed,
    placement: placement,
    offset: offset,
    crossOffset: crossOffset,
    content: props.children,
    delay: 75,
    closeDelay: 100,
    opened: opened,
    onOpenChange: onOpenChange
  });
}
let make = TooltipIcon;
export { make };
/* styles Not a pure module */